import PurchaseMediaConfirmModal from "./purchase-media-confirm-modal.component";

export default PurchaseMediaConfirmModal;
